import React from 'react';
import { object, string, bool, boolean } from 'yup';
import { navigate } from 'gatsby';
import LoginSignUp from '../../../common/components/RegisterForm/RegisterForm';
import ReqCreditReport from '../Components/ReqCreditReport/ReqCreditReport';
import { CreditReport } from '@fincity-frontend/shared-ui';
import {
  setAuthCookies as setToken,
  removeAuthCookies,
} from '../../../common/utils/cookie-utils';

import Otp from '../Components/Otp/Otp';
import {
  login,
  getConsumerOtp,
  consumerRegister,
  getUserProfile,
  saveConsumerLoan,
} from '../../../common/constants/api';
import { values } from 'lodash';

export default [
  {
    id: 'loginSignUp',
    component: () => <LoginSignUp consumer />,
    initialValues: {
      step: 'login',
      isForgotPassword: false,
      otp: '',
      firstName: '',
      lastName: '',
      mbNo: '',
      panNo: '',
      email: '',
      password: '',
      permission: false,
      isVerifiedByTruCaller: false,
      passwordFiledFocused:false

    },
    validationSchema: object().shape({
      email: string().when('step', {
        is: 'signUp',
        then: string()
          .required('Required')
          .max(50, 'Email address is Too Long!')
          .matches(
            /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
            'Please Enter Valid Email Id'
          ),
      }),
      firstName: string().when('step', {
        is: 'signUp',
        then: string().required('Required'),
      }),
      lastName: string().when('step', {
        is: 'signUp',
        then: string().required('Required'),
      }),
      mbNo: string().when('isForgotPassword', {
        is: false,
        then: string()
          .required('Required')
          .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number'),
      }),
      password: string().when('isForgotPassword', {
        is: false,
        then: string()
          .min(8, 'Password must be at least 8 characters')
          .max(15, 'Password must not be longer than 15 characters')
          .required('Password is required')
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            ' '
          ),
      }),
      panNo: string().when('step', {
        is: 'signUp',
        then: string()
          .required('Required')
          .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Incorrect format'),
      }),
      permission: bool().when('step', {
        is: 'signUp',
        then: bool()
          .test(
            'permission',
            'Must allow to access credit information ',
            (value) => value === true
          )
          .required('Must allow to access credit information'),
      }),
    }),
    onAction: async (sectionValues, formValues) => {
      if (sectionValues.isForgotPassword === false) {
        if (sectionValues.step === 'login') {
          await login({
            username: sectionValues.mbNo,
            userType: 4,
            password: sectionValues.password,
          })
            .then(async (res) => {
              let [id, token, username, userType] = [
                res.id,
                res.token,
                res.username,
                res.userType,
              ];
              setToken({ id, token, username, userType });
              let resp = await getUserProfile();
              localStorage.setItem('userData', JSON.stringify(resp));
              navigate('/user/home');
            })
            .catch((err) => {
              throw new Error(
                err?.response?.data?.message ||
                  'something went wrong! Please try again..'
              );
            });
        }
        if (sectionValues.step === 'signUp') {
          removeAuthCookies();
          if (sectionValues?.isVerifiedByTruCaller) {
            let requestId = JSON.parse(localStorage.getItem('action'))
              ?.requestId;

            let data = {
              name: {
                firstName: sectionValues?.firstName,
                middleName: '',
                lastName: sectionValues?.lastName,
              },
              phone: sectionValues?.mbNo,
              email: sectionValues?.email,
              password: sectionValues?.password,
              otp: '1111',
              pan: sectionValues?.panNo,
              truecallerRequestId: sectionValues?.reqId,
              ...(requestId ? { requestId: requestId } : {}),
            };
            await consumerRegister(data)
              .then(async (res) => {
                await login({
                  username: sectionValues?.mbNo,
                  userType: 4,
                  password: sectionValues?.password,
                })
                  .then(async (res) => {
                    let [id, token, username, userType] = [
                      res.id,
                      res.token,
                      res.username,
                      res.userType,
                    ];
                    setToken({ id, token, username, userType });
                    let resp = await getUserProfile();
                    localStorage.setItem('userData', JSON.stringify(resp));
                    let loanEligibility = sessionStorage.getItem(
                      'laonBeforeLogin'
                    );
                    if (loanEligibility) {
                      let laonData = JSON.parse(
                        sessionStorage.getItem('loanEligibilityData')
                      );
                      await saveConsumerLoan(laonData)
                        .then((res) => {})
                        .catch((err) => {
                          throw new Error(
                            err?.response?.data?.message ||
                              'something went wrong! Please try again..'
                          );
                        });
                    }
                  })
                  .catch((err) => {
                    throw new Error(
                      err?.response?.data?.message ||
                        'something went wrong! Please try again..'
                    );
                  });
              })
              .catch((err) => {
                throw new Error(
                  err?.response?.data?.message ||
                    'something went wrong! Please try again..'
                );
              });
          } else {
            await getConsumerOtp({
              email: sectionValues?.email,
              phone: sectionValues?.mbNo,
            })
              .then((res) => {})
              .catch((err) => {
                throw new Error(
                  err?.response?.data?.message ||
                    'something went wrong! Please try again..'
                );
              });
          }
        }
      }
    },
  },
  {
    id: 'otp',
    component: Otp,
    initialValues: {
      otp: '',
    },
    onAction: async (sectionValues, formValues) => {
      if (formValues?.loginSignUp?.isVerifiedByTruCaller) return;
      let requestId = JSON.parse(localStorage.getItem('action'))?.requestId;
      let data = {
        name: {
          firstName: formValues?.loginSignUp?.firstName,
          middleName: '',
          lastName: formValues?.loginSignUp?.lastName,
        },
        phone: formValues?.loginSignUp?.mbNo,
        email: formValues?.loginSignUp?.email,
        password: formValues?.loginSignUp?.password,
        otp: sectionValues?.otp,
        pan: formValues?.loginSignUp?.panNo,
        ...(requestId ? { requestId: requestId } : {}),
      };

      await consumerRegister(data)
        .then(async (res) => {
          await login({
            username: formValues?.loginSignUp?.mbNo,
            userType: 4,
            password: formValues?.loginSignUp?.password,
          })
            .then(async (res) => {
              let [id, token, username, userType] = [
                res.id,
                res.token,
                res.username,
                res.userType,
              ];
              setToken({ id, token, username, userType });
              let resp = await getUserProfile();
              localStorage.setItem('userData', JSON.stringify(resp));
              let loanEligibility = sessionStorage.getItem('laonBeforeLogin');
              if (loanEligibility) {
                let laonData = JSON.parse(
                  sessionStorage.getItem('loanEligibilityData')
                );
                await saveConsumerLoan(laonData)
                  .then((res) => {})
                  .catch((err) => {
                    throw new Error(
                      err?.response?.data?.message ||
                        'something went wrong! Please try again..'
                    );
                  });
              }
            })
            .catch((err) => {
              throw new Error(
                err?.response?.data?.message ||
                  'something went wrong! Please try again..'
              );
            });
        })
        .catch((err) => {
          throw new Error(
            err?.response?.data?.message ||
              'something went wrong! Please try again..'
          );
        });
    },
  },
  {
    id: 'reqCreditReport',
    component: ReqCreditReport,
  },
];
